import { Sidebar } from "../../shared/components";
import { AuthGuard } from "../../shared/guards/AuthGuard";
import { FinancialPassPresentation } from "./components/FinancialPassPresentation";

export const FinancialPassPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <FinancialPassPresentation />
            </Sidebar>
        </AuthGuard>
    );
};
